import sanitizeHtml from 'sanitize-html';

const SANITIZE_OPTIONS = {
    allowedTags: ['p', 'br', 'strong', 'b', 'em', 'i'],
    allowedAttributes: {},
};

/**
 * Turn company branding text into safe HTML.
 * Supports explicit HTML (<p>, <br>, <strong>) or plain text with blank lines between paragraphs.
 */
export function formatBrandingTextToHtml(text) {
    if (!text) return '';

    const trimmed = text.trim();
    if (!trimmed) return '';

    if (/<[a-z][\s\S]*>/i.test(trimmed)) {
        return sanitizeHtml(trimmed, SANITIZE_OPTIONS);
    }

    const paragraphs = trimmed.split(/\n\s*\n/);
    if (paragraphs.length > 1) {
        return paragraphs
            .map((paragraph) => {
                const withBreaks = sanitizeHtml(
                    paragraph.replace(/\n/g, '<br/>'),
                    SANITIZE_OPTIONS
                );
                return `<p>${withBreaks}</p>`;
            })
            .join('');
    }

    return sanitizeHtml(trimmed.replace(/\n/g, '<br/>'), SANITIZE_OPTIONS);
}
